function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.5 17.25C31.5052 19.2298 31.0426 21.1829 30.15 22.95C29.0916 25.0677 27.4646 26.8488 25.4512 28.094C23.4377 29.3391 21.1174 29.9991 18.75 30C16.7702 30.0052 14.8172 29.5426 13.05 28.65L4.5 31.5L7.35 22.95C6.4574 21.1829 5.99484 19.2298 6 17.25C6.00092 14.8827 6.66092 12.5623 7.90608 10.5489C9.15124 8.53542 10.9324 6.90839 13.05 5.85004C14.8172 4.95744 16.7702 4.49488 18.75 4.50004H19.5C22.6265 4.67253 25.5796 5.99218 27.7937 8.20633C30.0079 10.4205 31.3275 13.3735 31.5 16.5V17.25Z",
  stroke: "white",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgMessageCircle = function SvgMessageCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message-circle.f84afbc6.svg";
export { ForwardRef as ReactComponent };